import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IoniconsOutline } from '@pt/pt-models';

@Component({
  selector: 'pt-widget-nodata',
  template: `
    <p class='mb-2 px-2 d-flex'>
      {{ label }}
      <ng-container *ngIf="showEditBtn">
        <pt-icon [key]="IconEdit" *ngIf="disableEditBtn" class="text-gray-700 d-inline-flex ms-2" [size]="15"></pt-icon>
        <pt-icon [key]="IconEdit" *ngIf="!disableEditBtn"
                 container="body"
                 ngbTooltip='{{"LABELS.EDIT" | translate}}'
                 class="cursor-pointer d-inline-flex ms-2" [size]="15" (click)="clickEditBtn.emit()"></pt-icon>
      </ng-container>
    </p>
  `
})
export class WidgetNodataComponent implements OnChanges {
  @Input() showEditBtn = false;
  @Input() disableEditBtn = true;
  @Input() noDataLabel?: string; // this.i18n.stream('MESSAGE.NODATA');
  @Output() clickEditBtn = new EventEmitter<boolean>();

  label: string;
  IconEdit = IoniconsOutline.edit;


  constructor(private i18n: TranslateService) {

  }

  ngOnChanges(): void {
    if (this.noDataLabel) {
      this.label = this.noDataLabel;
    } else {
      this.i18n.stream('MESSAGE.NODATA').subscribe((t) => {
        this.label = t;
      });
    }
  }

}

